import { useContext, useEffect, useState } from "react"
//import { RiCloseFill } from "react-icons/ri"
import ApiContext from "src/provider/API/call-service"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { AppLabel, AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, ScreenTitle } from "src/style"
// import { ReactComponent as PopupLockIcon } from 'src/assets/img/forgot-password-lock.svg'
import PopupLockIcon from 'src/assets/svg/forgot-password-lock'
import { AppCenterPopup, CenterPopupHeader, CenterPopupHeaderD3 } from "src/component"
import { handleTypeNumberControl } from "src/utils/utility"
//import { Design } from 'src/model'

export const SecurityQuestionValidation: React.FC<any> = ({formData, handleInput, next, close}) => {
    const {API} = useContext(ApiContext)
    const {info: {institutionData}, setInfoProperty} = useContext(AppInfoContext)
    const [questions, setQuestions] = useState({securityQuestion1: '', securityQuestion2: ''})
    const [provideSecurityQuestion, setProvideSecurityQuestion] = useState<boolean|null>(null)

    useEffect(() => {
        handleFetchSecurityQuestions()
    }, [])

    async function handleFetchSecurityQuestions () {
        const response = await API.getSecurityQuestionsByUsername(formData?.username)
        if (response) {
            if (response.skipSecurityQuestion) {
                setProvideSecurityQuestion(false)
            }
            else {
                setQuestions({securityQuestion1: response.securityQuestion1, securityQuestion2: response.securityQuestion2})
                setProvideSecurityQuestion(true)
            }
        }
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        const response = provideSecurityQuestion ?
            await API.validateSecurityAnswers(formData)
            : await API.validateTxPin(formData?.username, formData.txPin)

        if (response) {
            await setInfoProperty('otpPhoneNo', response.phoneNo)
            next()
        }
    }

    return (
        <>
            { provideSecurityQuestion != null &&
                <AppCenterPopup height='46' zIndex='8' close={close}>
                    <CenterPopupHeader icon={<PopupLockIcon className='icon-component'/>} close={close} />
                    {/* { institutionData.design != Design.DESIGN_3 ?
                        <CenterPopupHeader icon={<PopupLockIcon className='icon-component'/>} close={close} />
                        :<CenterPopupHeaderD3 title='One Time Password' close={close} />
                    } */}
                    <CustomContainer height="35" className='popup-content-container'>
                        <CustomContainer topMargin="2">
                            <ScreenTitle textSize="2.2" fontWeight="700" align="center">
                                {provideSecurityQuestion ? 'Security Question' : 'Transaction Pin'}
                            </ScreenTitle>
                            <Form onSubmit={handleProceed} topMargin='2'>
                                { provideSecurityQuestion ?
                                    <>
                                        <AppText bottomMargin="2">Answer the following Security Questions</AppText>
                                        <FormGroup>
                                            <label>{questions.securityQuestion1}</label>
                                            <input 
                                                placeholder='Enter Answer' 
                                                name='securityAnswer1'
                                                autoComplete="off"
                                                value={formData.securityAnswer1}
                                                onChange={handleInput}
                                                required
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <label>{questions.securityQuestion2}</label>
                                            <input 
                                                placeholder='Enter Answer' 
                                                name='securityAnswer2'
                                                autoComplete="off"
                                                value={formData.securityAnswer2}
                                                onChange={handleInput}
                                                required
                                            />
                                        </FormGroup>
                                    </>
                                    :
                                    <>
                                        <AppLabel bottomMargin="2">Provide your transaction pin</AppLabel>
                                        <FormGroup>
                                            <label>Transaction Pin</label>
                                            <input 
                                                placeholder='XXXX'
                                                type='password' 
                                                name='txPin'
                                                autoComplete="new-password"
                                                value={formData.txPin}
                                                onChange={handleInput}
                                                onKeyDown={handleTypeNumberControl}
                                                onKeyUp={handleTypeNumberControl}
                                                required
                                            />
                                        </FormGroup>
                                        <AppText bottomMargin="3.5" textSize="1.2">Do not remember transaction pin? please contact your bank support</AppText>
                                    </>
                                }
                                
                                <Button 
                                    width='100' sizeUnit="%" height='4.4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F'
                                >
                                    Next
                                </Button>
                            </Form>
                        </CustomContainer>
                    </CustomContainer>
                </AppCenterPopup>
            }
        </>
    )
}